<template>
	<div style="width: 100%;">
		<c-form v-show="showFieldList.length" ref="form" name="custom_fields_value_json" link-parent>
			<c-title v-if="title">{{title}}</c-title>
			<c-form-item v-for="(item, i) in fieldList" v-show="!showFormulaField.includes(item) || (formulaDataReady && !hideField[item.field_code])" :key="i" :label="item.field_title" :required="item.config_json.attr.includes('required')" :tip="item.config_json.tip">
				<c-input v-if="item.config_json.type == 'text'"
					:type="item.config_json.attr.includes('textarea') ? 'textarea' : 'text'"
					:name="item.field_code"
					:disabled="item.config_json.attr.includes('readonly')"
					:suggest="item.config_json.attr.includes('suggest') ? {empty: true, add: item.config_json.attr.includes('addSuggest') ? '添加为新预设值' : false} : false"
					:placeholder="item.config_json.placeholder"
					@suggest="suggestHandle(item, arguments[0], arguments[1])"
					@add="addCustomSuggest(item, arguments[0], arguments[1])"
				></c-input>

				<c-input v-else-if="item.config_json.type == 'number'"
					type="number"
					:name="item.field_code"
					:decimal="item.config_json.attr.includes('decimal') ? item.config_json.decimal : 0"
					:disabled="item.config_json.attr.includes('readonly')"
					:placeholder="item.config_json.placeholder"
				></c-input>

				<c-datetime v-else-if="item.config_json.type == 'time'"
					:name="item.field_code"
					:type="item.config_json.format.split('|')[1]"
					:format="item.config_json.format.split('|')[0]"
					:time-accuracy="item.config_json.format.split('|')[2]"
					:disabled="item.config_json.attr.includes('readonly')"
					:placeholder="item.config_json.placeholder"
				></c-datetime>

				<template v-else-if="item.config_json.type == 'option'">
					<template v-if="item.config_json.mode == 'option'">
						<c-checkbox-group v-if="item.config_json.attr.includes('multiple')"
							:name="item.field_code"
							:options="item.config_json.options"
							:disabled="item.config_json.attr.includes('readonly')"
						></c-checkbox-group>

						<c-radio-group v-else
							:name="item.field_code"
							:options="item.config_json.options"
							:disabled="item.config_json.attr.includes('readonly')"
						></c-radio-group>
					</template>

					<c-select v-else
						:name="item.field_code"
						:options="item.config_json.options"
						:multiple="item.config_json.attr.includes('multiple')"
						:disabled="item.config_json.attr.includes('readonly')"
						:placeholder="item.config_json.placeholder || '请选择'"
						:search="{add: item.config_json.attr.includes('add')}"
						@add="addCustomOption(item, arguments[0], arguments[1], arguments[2])"
					></c-select>
				</template>

				<c-upload-file v-else-if="['file', 'image'].includes(item.config_json.type)"
					:name="item.field_code"
					:type="item.config_json.type == 'file' ? item.config_json.suffix.join(',') : 'image'"
					:multiple="item.config_json.attr.includes('multiple') ? 30 : false"
				></c-upload-file>

				<c-select v-else-if="item.config_json.type == 'rel_object'"
					:name="item.field_code"
					:value-data="objectValueData[item.field_code]"
					:placeholder="item.config_json.placeholder || '请选择'"
					async
					@search="searchObjectOption(item, arguments[0], arguments[1])"
					@change="objectFieldHandle(item, $event)"
				></c-select>

				<c-formula v-else-if="item.config_json.type == 'formula'"
					:name="item.field_code"
					:formula="item.config_json.formula"
				></c-formula>
			</c-form-item>
		</c-form>
		<c-form v-show="false" ref="dataForm" name="customFieldValues"></c-form>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import {debounce} from '@deanwu/vue-component-library'
	import {parseFormula} from '@/assets/script/formula.js'

	export default {
		name: 'customForm',

		props: {
			workType: [String, Number],
			title: String
		},

		data() {
			return {
				formulaDataReady: false,
				hideField: {},
				objectValueData: {}
			}
		},

		computed: {
			...mapState(['customField']),

			fieldList() {
				return this.customField[this.workType] || [];
			},

			showFieldList() {
				return this.fieldList.filter(item => !this.showFormulaField.includes(item) || (this.formulaDataReady && !this.hideField[item.field_code]));
			},

			rule() {
				let rule = {};
				this.fieldList.map(item => {
					if (item.config_json.attr.includes('required') && !this.hideField[item.field_code]) {
						rule[`custom_fields_value_json.${item.field_code}`] = `${item.field_title}不能为空`;
					}
				});
				return rule;
			},

			defaultData() {
				let data = {}, object = false;
				this.fieldList.map(item => {
					if (item.config_json.default) {
						if (item.config_json.default.type == 1) {
							if (item.config_json.type == 'time') {
								data[item.field_code] = new Date().format(item.config_json.format.split('|')[0]);
							} else {
								data[item.field_code] = item.config_json.default.value;
							}
						} else if (item.config_json.default.type == 2) {
							if (!object) {
								object = {};
							}
							object[item.field_code] = '';
						}
					}
				})

				return {
					data,
					object
				}
			},

			formulaField() {
				return this.fieldList.filter(item => item.config_json.type == 'formula');
			},

			showFormulaField() {
				return this.fieldList.filter(item => item.config_json.show && item.config_json.show.type == 1);
			}
		},

		created() {
			this._formulaDataReady = debounce(() => {
				this.formulaDataReady = true;
				this._formulaDataReadyLoad && this._formulaDataReadyLoad.$loadOver();
				delete this._formulaDataReadyLoad;
			}, 500);

			this._formulaHandle = debounce(() => {
				if (!this.showFormulaField.length && !this.formulaField.length) return;
				this.afterInit(() => {
					let data = Object.assign({}, this._formulaDataSource);
					Object.keys(this._formulaFormSource).forEach(key => {
						let sysData = this._formulaFormSource[key].form.get();
						let customData = sysData.custom_fields_value_json
						delete sysData.custom_fields_value_json;
						data[key] = Object.assign({}, data[key], sysData, customData);
					});

					this.showFormulaField.forEach(field => {
						let value = parseFormula(field.config_json.show.formula, data);
						this.$set(this.hideField, field.field_code, !value);
					});

					this.formulaField.forEach(field => {
						let value = parseFormula(field.config_json.formula, data, {
							valueType: field.config_json.value_type
						});
						this.$refs.form.set({
							[field.field_code]: value
						});
					});
				});
			}, 200);
		},

		mounted() {
			this._setFormData = this.$refs.form.set;
			this.$refs.form.set = data => {
				this.afterInit(() => {
					this._setFormData(data);
				});
			}

			this.$refs.dataForm.set = data => {
				Object.keys(data).forEach(code => {
					if (data[code].display_value) {
						this.$set(this.objectValueData, code, [{
							name: data[code].display_value,
							value: data[code].value
						}])
					}
				});
			}
		},

		methods: {
			init(options = {}) {
				this.formulaDataReady = false;
				this._init = false;
				this._manualEvent = false;
				this._formulaFormSource = {};
				this._formulaDataSource = {};
				this.hideField = {};
				this.objectValueData = {};

				if (options.formulaSource) {
					options.loading && (this._formulaDataReadyLoad = this.$loading());
					this._formulaFormSource = Object.assign({}, options.formulaSource);
					Object.keys(this._formulaFormSource).forEach(key => {
						let source = this._formulaFormSource[key];
						if (source.update) {
							source.update = debounce(source.update, source.updateTimer || 500);
						}
						this.watchUnitUpdate(source, source.form);
						this.afterInit(() => {
							this.watchUnitUpdate(source, source.form);
						});
					});
					this.afterInit(() => {
						this._formulaHandle();
					});
				} else {
					this.formulaDataReady = true;
				}
				
				this.$store.dispatch('updateFieldConfig', () => {
					this.$nextTick(() => {
						this._init = true;
						this.reset();
						if (this._initQueue) {
							this._initQueue.forEach(item => {
								item();
							});
							delete this._initQueue;
						}
					});
				});
			},

			ready(fun) {
				if (this.formulaDataReady) {
					fun();
				} else {
					this.$message({
						message: '请等待数据加载完成'
					});
				}
			},

			reset() {
				this.$refs.form.clear();
				this._setFormData(this.defaultData.data);
			},

			afterInit(handler) {
				if (!this._init) {
					if (!this._initQueue) {
						this._initQueue = [];
					}
					this._initQueue.push(handler);
				} else {
					handler();
				}
			},

			suggestHandle(item, keyword, resolve) {
				if (item.config_json.attr.includes('suggest')) {
					resolve(item.config_json.suggest.filter(item => item.includes(keyword)));
				}
			},

			addCustomSuggest(item, value, resolve) {
				this.request({
					url: '/sys_field/edit',
					data: {
						id: item.id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							suggest: item.config_json.suggest.map(item => item).concat([value])
						}))
					},
					loading: true,
					success: () => {
						resolve(value);
						item.config_json.suggest.push(value);
					}
				});
			},

			addCustomOption(item, event, name, resolve) {
				let option = {
					name,
					value: name
				}
				this.request({
					url: '/sys_field/edit',
					data: {
						id: item.id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							options: item.config_json.options.map(item => item).concat([option])
						}))
					},
					loading: true,
					success: () => {
						resolve(option);
					}
				});
			},

			searchObjectOption(field, keyword, resolve) {
				this.request({
					url: '/sys_field/relation/data_list',
					data: {
						relation_field_id: field.id,
						keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.display_value,
								value: item.id
							}
						}))
					}
				})
			},

			objectFieldHandle(field, data) {
				data.value && this.request({
					url: '/sys_field/relation/fill',
					data: {
						work_type_id: this.workType,
						relation_field_id: field.id,
						target_id: data.value
					},
					success: data => {
						this.$refs.form.set(data);
					}
				})
			},

			setDefaultData(source) {
				this.afterInit(() => {
					if (this.defaultData.object && source) {
						this.request({
							url: '/sys_field/default/values',
							data: source,
							success: data => {
								this.$refs.form.set(Object.assign({}, this.defaultData.object, data[0]));
							}
						})
					}
				});
			},

			setFormulaSource(data) {
				this._formulaDataSource = this._formulaDataSource || {};
				Object.keys(data).forEach(key => {
					let sysData = Object.assign({}, data[key]);
					let customData = Object.assign({}, sysData.custom_fields_value_json)
					delete sysData.custom_fields_value_json;
					this._formulaDataSource[key] = Object.assign({}, sysData, customData);
				});
				this._formulaHandle();
			},

			watchUnitUpdate(source, form) {
				form.eachUnit(item => {
					if (item.$options.name == 'cForm' && item.name == 'custom_fields_value_json') {
						this.watchUnitUpdate(source, item);
						return;
					}
					if (item.$options.name == 'cFormItem') return;
					if (item._formulaEvent) return;
					item._formulaEvent = true;

					let watchVar;
					switch (item.$options.name) {
					case 'cSelect':
					case 'cTransfer':
						watchVar = 'currentValue';
						break;

					default:
						watchVar = 'valueData';
					}

					this.$watch(() => item[watchVar], debounce(() => {
						if (source.watch || source.update) {
							let data = source.form.get();
							source.watch && source.watch[item.name] && source.watch[item.name](data, this.setFormulaSource);
							source.update && source.update(data);
						}
						this._formulaHandle();
						this._formulaDataReady();
					}, 200));

					item.$on(item.$options.name == 'cInput' ? 'focus' : 'change', () => {
						this._manualEvent = true;
					});
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
